<template>
  <div>
    <!-- ============================================================== -->
    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container-fluid">
      <!-- ============================================================== -->
      <!-- Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/home">Home</router-link>
            </li>
            <li class="breadcrumb-item active">申し送りテンプレート一覧</li>
          </ol>
        </div>
      </div>
      <!-- ============================================================== -->
      <!-- End Bread crumb and right sidebar toggle -->
      <!-- ============================================================== -->
      <div class="row">
        <div class="col-12">
          <!-- Column -->
          <div class="card">
            <div class="card-body">
              <div class="dataTables_wrapper dt-bootstrap no-footer">
                <div class="row">
                  <div class="col-1">
                    <div class="p-xl-3">
                      <button type="submit" class="btn btn-success btn-circle" :disabled="isProcessing"
                              @click="search">
                        <i class="fa fa-search"></i>
                      </button>
                    </div>
                  </div>
                  <div class="col-4"></div>
                  <div class="col-3">
                    <div class="data-actions">
                      <router-link to="/instruction_new" class="btn btn-rounded btn-outline-info">
                        <i class="fa fa-plus"></i>新規登録する
                      </router-link>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="page">
                  <div class="col-sm-12">
                    <div class="table-responsive" v-if="page.data.length > 0">
                      <table id="myTable" class="table table-sm table-bordered">
                        <thead>
                        <tr>
                          <th>テンプレート名</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="template in page.data" :key="template.id">
                          <td>
                            <router-link :to="`/instruction/${template.id}`">{{template.display_name}}</router-link>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-else>
                      <div class="alert alert-warning">
                        <p><i class="fa fa-info-circle p-r-10"/>該当するデータが見つかりませんでした。</p>

                        <p>検索のヒント</p>
                        <ul>
                          <li>
                            検索条件を変更してみてください。
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <pagination :page="page" v-if="page && page.data.length > 0" @change="changePage"/>
              </div>
            </div>
          </div>
          <!-- Column -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../libs/Api'
import constants from '../../constants'
import Pagination from '../../components/Pagination'

export default {
  name: 'InstructionTemplate',
  components: {
    Pagination
  },
  data () {
    return {
      page: null
    }
  },
  mounted: function () {
    this.search()
  },
  methods: {
    changePage (page) {
      this.search(page)
    },
    search (page = 1) {
      this.exec(_this => {
        _this.isProcessing = true
        return api.getInstructionTemplate(constants.QUERY_MODE_PAGING, page)
          .then(res => {
            _this.page = res
          })
          .finally(() => {
            _this.isProcessing = false
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.data-actions {
  text-align: right;
}
</style>
